import React from "react";
import "../Style/Addresssection.css";

const offices = [
  {
    id: 1,
    title: "Head Office",
    address: `MPeoples Business Solutions Pvt Ltd,\n41-A1, 1st floor, Ramaniyagam Complex,\nSeva Street, Jayamkondacholapuram,\nUdayarpalayam, Ariyalur- 621802.`,
  },
  {
    id: 2,
    title: "Salem Branch",
    address: `MPeoples Business Solutions Pvt Ltd,\nNo 56/3-1 Ranga Nagar, 3rd Cross Street,\nSuramangalam, Salem-636005.`,
  },
  {
    id: 3,
    title: "Palakkad Branch",
    address: `MPeoples Business Solutions Pvt Ltd,\nPalakkad, Kerala.`,
  },
  {
    id: 4,
    title: "Coimbatore Branch",
    address: `MPeoples Business Solutions Pvt Ltd,\nCoimbatore, Tamil Nadu.`,
  },
];

function AddressSection() {
  return (
    <section className="address-section">
      <div className="address-grid">
        {offices.map((office) => (
          <div className="address-card" key={office.id}>
            <div className="card-icon-wrap">
              <svg
                className="card-icon"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 22s7-7.58 7-12.5A7 7 0 0 0 5 9.5C5 14.42 12 22 12 22Z"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinejoin="round"
                />
                <circle
                  cx="12"
                  cy="9.5"
                  r="2.6"
                  stroke="currentColor"
                  strokeWidth="1.6"
                />
              </svg>
            </div>
            <h3 className="card-title">{office.title}</h3>
            <div className="card-divider" />
            <p className="card-address">
              {office.address.split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default AddressSection;